import mixpanel from "mixpanel-browser";
import ips from "./ip-blacklist.json";
import {readStorage, writeStorage} from "../utils/storage";

let env_check = process.env.NODE_ENV;

const DEV_HOSTNAMES = ["localhost", "127.0.0.1", "amswidget-accessibility-dev.handiscover.com"];

// the pages that send their events to the dev project: a local or dev widget host, or a demo page
export const isDevLocation = ({ hostname, pathname }) => (
  DEV_HOSTNAMES.includes(hostname) || pathname.split("/").includes("demo")
);

if (env_check === "development" || isDevLocation(window.location)) {
  mixpanel.init("4d695739007ee9deb43c37c489ba96d4", { ignore_dnt: true, api_host: "https://api-eu.mixpanel.com" });
  // Set a default test user for less charging on this dev instance
  mixpanel.identify("mixpanelTestUser@handiscover.com");
} else {
  mixpanel.init("419371d9c7988ebf9fc1cb5c0679b0ca", { ignore_dnt: true, api_host: "https://api-eu.mixpanel.com" });
}

async function getIP() {
  const response = await fetch("https://api.ipify.org/?format=json");
  const client = await response.json();
  return client.ip;
}

getIP().then((result) => {
  writeStorage("ipExist", ips.blacklist.includes(result));
});

// Without the cookie consent the widget only tracks when it is not opened full screen on its own page:
// when a client embeds it, or when it runs in an iframe. The mode is read on every call, App stores it
// when it mounts, after this module is loaded; while it is unknown the widget is taken as full screen.
const canTrack = () => {
  const cookieConsent = readStorage('cookie-consent', false)
  const fullscreen = readStorage('fullscreen', null)
  const isInIframe = window.self !== window.top
  return cookieConsent === true || fullscreen === false || isInIframe
}

function getActions() {
  let enclosedIDs = {
    companyId: null,
    propertyId: null,
    buildingAreaId: null,
  };
  return {
    track: (name, props) => {
      if (canTrack()) {
        mixpanel.track(name, { ...props, ...enclosedIDs });
        if (readStorage("ipExist", false) === true) {
          mixpanel.register({ $ignore: "true" });
        }
      }
    },
    setGroup: ({ companyId, propertyId = null, buildingAreaId = null }) => {
      enclosedIDs = { companyId, propertyId, buildingAreaId };
      if (canTrack()) {
        mixpanel.set_group("company_id", companyId);
        mixpanel.register({
          companyId,
          propertyId,
          buildingAreaId,
        });
      }
    },
    };
  }

let actions = getActions();

if (process.env.NODE_ENV === "development") {
  console.log("environment check: ", env_check);
}

export let Mixpanel = actions;
